<template>
  <div>
  <v-btn  v-if="changed && pagination.totalItems === 0" large block color="primary" @click="create" :loading="loading" :disabled="loading">โหลดรายชื่อ</v-btn> 
 
  <v-card class="elevation-0" v-else>
    <v-card-title>
      รายชื่อผู้ร้องขอบัญชีอินเตอร์เนต <span v-if="academicYear" class="ml-2 primary--text">ภาคการศึกษาที่ {{ academicYear.semesterYear }}</span>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="pagination.q"
        append-icon="search"
        label="ค้นหา"
        single-line
        hide-details
      ></v-text-field>
      <v-spacer></v-spacer>
      <v-select
        :items="statusItems"
        v-model="pagination.status"
        label="สถานะ"
        item-text="text"
        item-value="value"
        box
        class="mt-3"
      ></v-select>
    </v-card-title>
    <v-data-table
      :loading="loading"
      :headers="headers"
      :items="items"
      :total-items="pagination.totalItems"
      :pagination.sync="pagination"
    >
      <template slot="items" slot-scope="props">
        <td>{{ props.item.requestorFullname }}</td>
        <td class="text-xs-center">{{ props.item.status | requestStatus }}</td>
        <td class="text-xs-center">{{ props.item.receivedDate | formatShortDate }}</td>
        <td>{{ props.item.recipientFullname }}</td>
        <td>
          <template v-if="hasAccess(allowedRoles)">
            <v-icon
              small
              color="primary"
              class="mr-2"
              @click="editItem(props.item)"
              v-if="props.item.status === 'NEW' || props.item.status === 'APPROVED'" 
            >
              edit
            </v-icon>
            <v-icon
              color="green"
              class="mr-2"
              v-if="props.item.status === 'COMPLETED'" 
            >
              check_circle_outline
            </v-icon>
          </template>
        </td>
      </template>
      <!-- <v-alert slot="no-results" :value="true" color="error" icon="warning">
        Your search for "{{ pagination.q }}" found no results.
      </v-alert> -->
    </v-data-table>
    <div class="text-xs-center pt-2">
      <v-pagination v-model="pagination.page" :length="pages" :total-visible="7"></v-pagination>
    </div>

    <v-dialog v-model="dialog" max-width="500px">
      <v-card>
        <v-card-title class="title font-weight-light">
          <v-icon
            class="mr-2"
          >
            edit
          </v-icon><span>{{ formTitle }}</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm12 md12>
                <div v-if="processStatus === 'NEW'">
                  <v-switch
                    v-model="editedItem.status"
                    label="อนุมัติแล้ว"
                    color="success"
                    value="APPROVED"
                    hide-details
                  ></v-switch>
                </div>
                <div v-if="processStatus === 'APPROVED'">
                  <v-switch
                    v-model="editedItem.status"
                    label="รับแล้ว"
                    color="success"
                    value="COMPLETED"
                    hide-details
                  ></v-switch>
                </div>
              </v-flex>
            </v-layout>

            <v-expand-transition>
              <v-layout wrap v-if="editedItem.status === 'COMPLETED'">
                <v-flex xs12 sm12 md12>
                  <v-menu
                    :close-on-content-click="false"
                    v-model="menu"
                    :nudge-top="30"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    max-width="290px"
                    min-width="290px"
                  >
                    <v-text-field
                      slot="activator"
                      :value="date(editedItem.receivedDate)" 
                      label="วันที่รับ"
                      prepend-icon="event"
                      readonly
                      outline
                    ></v-text-field>
                    <v-date-picker 
                      v-model="editedItem.receivedDate" 
                      no-title 
                      locale="th-Th"
                      @input="menu = false"></v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs12 sm12 md12>
                  <v-autocomplete
                    :items="personItems"
                    v-model="editedItem.recipient"
                    item-value="id"
                    item-text="fullname"
                    label="ผู้รับ"
                    prepend-icon="person"
                    outline
                  ></v-autocomplete>
                </v-flex>
              </v-layout>
            </v-expand-transition>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="grey white--text" @click.native="close">ยกเลิก</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="success" dark @click.native="save">บันทึก</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
  </div>
</template>

<script>
import swal from 'sweetalert2'
import { hasAccessMixin } from '@/mixins/hasAccessMixin'

export default {
  props: ['academicYear', 'personItems'],
  mixins: [ hasAccessMixin ],
  data () {
    return {
      allowedRoles: ['ROLE_ADMIN', 'ROLE_SERVICE'],
      changed: true,
      dialog: false,
      menu: false,
      loading: false,
      headers: [
        { text: 'ชื่อ-นามสกุล', align: 'left', sortable: false, value: 'requestorFullname'}, 
        { text: 'สถานะ', align: 'center', sortable: true, value: 'status'}, 
        { text: 'วันที่รับ', align: 'center', sortable: false, value: 'receivedDate'}, 
        { text: 'ผู้รับ', align: 'left', sortable: false, value: 'recipientFullname'}, 
        { text: '', sortable: false} 
      ],
      statusItems: [
        { text: 'ทั้งหมด', value: '' },
        { text: 'คำร้องใหม่', value: 'NEW' }, 
        { text: 'อนุมัติแล้ว', value: 'APPROVED' }, 
        { text: 'รับแล้ว', value: 'COMPLETED' }
      ],
      items: [],
      pagination: {
        q: '',
        sortBy: 'status',
        descending: true,
        page: 1,
        rowsPerPage: 10,
        totalItems: 0,
        academicYear: null,
        status: ''
      },
      editedIndex: -1,
      editedItem: {
        status: '',
        receivedDate: null,
        recipient: null
      },
      defaultItem: {
        status: '',
        receivedDate: null,
        recipient: null
      },
      processStatus: null
    }
  },
  mounted () {
    // console.log('DataTable mounted...')
    this.reload()
  },
  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'New Item' : `ดำเนินการ ${this.editedItem.requestorFullname}`
    },
    pages () {
      if (this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      ) return 0

      return Math.ceil(this.pagination.totalItems / this.pagination.rowsPerPage)
    }
  },
  methods: {
    close () {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 200)
      this.reload()
    },
    date (val) {
      return this.$options.filters.formatFullDate(val)
    },
    editItem (item) {
      this.processStatus = item.status
      this.editedIndex = this.items.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },
    save () {
      // console.log('save called...', this.editedItem)
      this.$store.dispatch('internetRequest/update', this.editedItem)
        .then((response) => {
          // console.log('onSave:', response )
          this.loading = false
          swal({
            title: 'Success!',
            type: 'success'
          }).then(response => {
            this.close()
          })
        }).catch((error) => {
          this.loading = false
          swal('Error!', error.message, 'error')
        })
    },
    create () {
      this.loading = true
      this.$store.dispatch("internetRequest/create", this.academicYear.id)
        .then((response) => {
          this.reload ()
        }).catch((error)=>{
          console.log('reload', error)
        })
    },
    reload () {
      this.loading = true
      console.log('reload by academicYear id: ', this.academicYear)
      if(this.academicYear) this.pagination.academicYear = this.academicYear.id
      this.$store.dispatch("internetRequest/loadItemsAsPage", this.pagination)
        .then((response) => {
          // console.log('totalItems', response.data.totalItems)
          // console.log('items', response.data.items)
          this.pagination.totalItems = response.data.totalItems
          this.items = response.data.items
          this.loading = false
          this.$emit('active', true)
        }).catch((error)=>{
          this.loading = false
          console.log('reload', error)
        })
    }
  },
  watch: {
    /*'pagination.rowsPerPage' () {
      this.reload()
    },
    'pagination.q' () {
      this.changed = false
      this.reload()
    },
    'pagination.page' () {
      this.reload()
    },
    'pagination.descending' () {
      this.reload()
    },
    'academicYear' (val) {
      // console.log('watching academicYear id: ', val)
      this.changed = true
      setTimeout( ()=> this.reload (), 1000)
      
    }*/
    pagination: {
      handler (val) {
        this.reload()
        if(val.q) this.changed = false
      },
      deep: true
    },
    'academicYear' (val) {
      // console.log('watching academicYear id: ', val)
      this.changed = true
      setTimeout( ()=> this.reload (), 1000)
      
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/management/internet/dataTable.vue